import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const TextTerminationProcessing = () => (
  <DynamicContent
    configPath={REMOTE_CONFIG_PATHS.PRIVACY_POLICY.TERMINATION_PROCESSING}
    renderAsHtml={true}
  />
);
